import * as React from 'react'
function SvgParameterV(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M13.25 20c2.975 0 5.25 2.275 5.25 5.25 0 2.275-1.4 4.2-3.5 4.9v2.1c0 1.05-.7 1.75-1.75 1.75s-1.75-.7-1.75-1.75v-2.1c-1.925-.7-3.5-2.625-3.5-4.9C8 22.275 10.275 20 13.25 20zm14 3.5c1.05 0 1.75.7 1.75 1.75v7c0 1.05-.7 1.75-1.75 1.75s-1.75-.7-1.75-1.75v-7c0-1.05.7-1.75 1.75-1.75zm0-17.5C28.3 6 29 6.7 29 7.75v2.1c1.925.7 3.5 2.625 3.5 4.9 0 2.975-2.275 5.25-5.25 5.25S22 17.725 22 14.75c0-2.275 1.575-4.2 3.5-4.9v-2.1c0-1.05.7-1.75 1.75-1.75zm-14 0C14.3 6 15 6.7 15 7.75v7c0 1.05-.7 1.75-1.75 1.75s-1.75-.7-1.75-1.75v-7c0-1.05.7-1.75 1.75-1.75z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgParameterV
